export default "__VITE_ASSET__c1f24d39__"